module.exports = __webpack_public_path__ + "79db41cc9874047c6936f3b448b4ee1b.svg";